import {
  ListInternationalProductLiabilityClaimsCommand,
  ListInternationalProductLiabilityClaimsInput,
  ListInternationalProductLiabilityClaimsOutput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function listIPLClaimsService(input: ListInternationalProductLiabilityClaimsInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }
  const client = setupClaimIntakeClient(token);
  const command = new ListInternationalProductLiabilityClaimsCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listIPLClaims");

  return await client
    .send(command)
    .then((response: ListInternationalProductLiabilityClaimsOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
